import axios from "axios";
import React, { FC, useEffect, useState } from "react";
import MainLayout from "src/components/MainLayout";
import { AppConfig } from "src/config/AppConfig";
import { useAppDispatch, useAppSelector } from "src/hooks/redux/hooks";
import "../workers/WorkerCategories.css"
import Swal from "sweetalert2";
import eye from "../../../assets/img/icons/eye-solid.svg"
import "../doorstepServices/DoorstepServices.css"
import { IAppliedWorker, IRequirement } from "src/helper/interfaces";
import FilterButton from "src/components/layout/FilterButton";
import Cookies from "js-cookie";
import moment from "moment";
import Paginator from "src/components/layout/Paginator";
import bill from "../../../assets/img/icons/marketing-bill-payment-invoice-receipt-svgrepo-com.svg";
import LoadingGif from "src/components/layout/Loader";
import { startLoading, stopLoading } from "src/store/loading/loadingSlice";
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable';
import ExportDocs from "src/components/layout/ExportDocs";
import { formatDiffrentDate } from "src/utils/normalFuntions";
import { Link } from "react-router-dom";

const getAllRequirements = async (
   token: string,
   pageNumber: number,
   pageSize: number,
   searchValue: string,
   requirementType: string,
   startDate?: string,
   endDate?: string
) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/requiremens`, {
      headers: {
         "x-access-token": token
      },
      params: {
         service_type: "normal_worker",
         page: pageNumber,
         requirement_type: requirementType,
         search_value: searchValue,
         pageSize,
         start_date: startDate,
         end_date: endDate
      }
   })
};

// const getAppliedWorkers = async (
//    token: string, id: string,
//    pageNumber: number, pageSize: number
// ) => {
//    return await axios.get(`${AppConfig.DEV_SERVER}/requirement/applied-workers/${id}`, {
//       headers: {
//          "x-access-token": token
//       },
//       params: {
//          page: pageNumber,
//          pageSize,

//       }
//    })
// }

export type sidePages = {
   appliedworkers: boolean,
}

const WorkRequirements = () => {


   // const [selectedOption, setSelectedOption] = useState("job");
   const selectedOption = useAppSelector((state) => state?.requirementAnsSupport?.requirementType?.value);
   const Token = Cookies.get('token');
   // const [selectedRequirement, setSelectedRequirement] = useState<IRequirement>();
   const [searchVal, setSearchVal] = useState('');
   const [requirements, setRequirements] = useState<IRequirement[]>([])
   const [pageNo, setPageNo] = useState(1);
   const [pageSize, setPageSize] = useState(20);
   const [totalPages, setTotalPages] = useState(0);
   const [startDate, setStartDate] = useState<Date | undefined>(undefined);
   const [endDate, setEndDate] = useState<Date | undefined>(undefined);
   // const [hideAllFilters, setHideAllFilters] = useState(false);
   const startingDate = startDate ? startDate.toISOString() : undefined;
   const endingDate = endDate ? endDate.toISOString() : undefined;
   const loading = useAppSelector(state => state.loading.value);
   // const [totalAppliedData, setTotalAppliedData] = useState({
   //    appliedCount: 0,
   //    viewedCount: 0
   // });
   // const [appliedWorkers, setAppliedWorkers] = useState<IAppliedWorker[]>([]);
   const [PaginatedData, setPaginatedData] = useState({
      pageNo: 1,
      pageSize: 20,
      totalPages: 0
   });
   // const [clickedSidePage, setClickedSidePage] = useState<sidePages>({
   //    appliedworkers: true
   // });

   const doc = new jsPDF();
   doc.text("Transactions Report", 14, 10);


   const formattedData = requirements.map((item: IRequirement, i) => {
      // Construct address from the "address" field
      const address = item?.address
         ? `${item.address.city || ''}, ${item.address.state || ''}, ${item.address.country || ''} - ${item.address.pin_code || ''}`
         : 'NA';

      // Work requirements list as a comma-separated string
      const workRequirements = Array.isArray(item?.work_requirement) ? item.work_requirement.join(", ") : 'NA';

      // console.log(materialRequirements);
      const materialRequirements = item?.material_requirement?.map((data) => data?.materialName) || [];

      const jobRequirements = Array.isArray(item?.hiring_type) ? item.hiring_type.join(", ") : 'NA';

      return {
         unique_id: item?.unique_id || "",
         user_name: item?.user_name || "",
         user_phone: item?.user_phone || "",
         approx_area: item?.approx_area || "",
         estimated_budget: item?.estimated_budget || "",
         salary_offered: item?.salary_offered || "",
         urgent_looking: item?.urgent_looking || "Not Urgent",
         work_requirement: workRequirements || "NA",
         material_requirement: materialRequirements || "NA",
         hiring_type: jobRequirements || "NA",
         vacancy_count: item?.vacancy_count || 0,
         address: address || "NA",
         createdAt: new Date(item?.createdAt).toLocaleDateString() || "NA",
      };
   });

   const headers = [
      // { label: "Sr.No.", key: "no" },
      { label: `${selectedOption === "Job" ? "Job ID" : selectedOption === "Material" ? "Material ID" : "Requirement ID"}`, key: "unique_id" },

      { label: `${selectedOption === "Job" ? "Employer Name" : "Customer Name"}`, key: "user_name" },

      { label: `${selectedOption === "Job" ? "Employer Phone" : "Customer Phone"}`, key: "user_phone" },

      { label: `${selectedOption === "Work" ? "Approx Area" : ''}`, key: `${selectedOption === "Work" ? "approx_area" : ""}` },

      { label: `${selectedOption === "Job" ? "Salery Offered" : "Estimated Budget"}`, key: `${selectedOption === "Job" ? "salary_offered" : "estimated_budget"}` },

      { label: "Urgent Looking", key: "urgent_looking" },

      { label: `${selectedOption === "Job" ? "Job Requirements" : selectedOption === "Material" ? "Material Requirements" : "Work Requirements"}`, key: `${selectedOption === "Job" ? "hiring_type" : selectedOption === "Material" ? "material_requirement" : "work_requirement"}` },
      { label: `${selectedOption === "Job" ? "Vacancy Count" : ""}`, key: "vacancy_count" },
      { label: "Address", key: "address" },
      { label: "Created At", key: "createdAt" },
   ];

   const exportPDF = () => {
      // Table columns and data
      const tableColumns = [
         // "Sr.No.",
         `${selectedOption === "Work" ? "Requirement Id" : selectedOption === "Job" ? "Job Id" : "Material Id"}`,
         "User Name",
         "User Phone",
         "Approx Area",
         "Estimated Budget",
         "Urgent Looking",
         `${selectedOption === "Job" ? "Job Requirement" : selectedOption === "Material" ? "Material Requirement" : "Work Requirement"}`,
         "Address",
         "Created At",
      ];
      const tableData = formattedData.map(item => [
         // item.no || 0,
         item.unique_id || '',
         item.user_name || '',
         item.user_phone || '',
         item.approx_area || '',
         item.estimated_budget || '',
         item.urgent_looking || '',
         item.work_requirement || '',
         item.material_requirement || '',
         item.hiring_type || '',
         item.address || '',
         item.createdAt || ''
      ]);


      autoTable(doc, {
         columns: tableColumns,
         body: tableData,
         startY: 20, // Start position below the title
         styles: {
            fontSize: 10, // Use a reasonable font size for better readability
            overflow: 'linebreak', // Allow text wrapping in the cell
            cellPadding: 2, // Add padding to cells for better readability
            halign: 'center', // Align content in the center
            // cellWidth: 'wrap', // Dynamically wrap text
         },
         columnStyles: {
            // Adjust specific column widths for better fit
            _id: { cellWidth: 40 },
            name: { cellWidth: 50 },
            phone: { cellWidth: 50 },
            approx_area: { cellWidth: 30 },
            estimated_budget: { cellWidth: 40 },
            urgent_looking: { cellWidth: 40 },
            work_requirements: { cellWidth: 60 },
            address: { cellWidth: 80 }, // Increase width for the address column
            createdAt: { cellWidth: 50 },
         },
         theme: 'grid', // Optional: Apply grid theme for better structure
         pageBreak: 'auto', // This will automatically add page breaks when content exceeds the page height
         margin: { top: 10, left: 10, bottom: 10, right: 10 }, // Adjust margins to control spacing
      });
      doc.save("requirements_export.pdf");
   };


   useEffect(() => {
      if (Token) {
         dispatch(startLoading());
         getAllRequirements(Token as string, pageNo, pageSize, searchVal, selectedOption, startingDate, endingDate).then((res) => {
            // console.log(res)
            if (res?.data?.status_code === 200) {
               setRequirements(res?.data?.data?.data);
               setTotalPages(res?.data?.data?.totalPages);
               dispatch(stopLoading());
            } else {
               dispatch(stopLoading());
               Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: `${res?.data?.data?.msg}`,
                  footer: '<a href="#">Why do I have this issue?</a>'
               });
            }
         }).catch(err => {
            throw err
         })
         // .finally(() => {
         //    dispatch(stopLoading())
         // })
      }


      // dispatch(startLoading())
   }, [Token, pageNo, pageSize, searchVal, selectedOption, startDate, endDate]);

   const dispatch = useAppDispatch();
   useEffect(() => {
      setPageNo(1)
   }, [selectedOption])


   // useEffect(() => {
   //    if (selectedRequirement?._id) {
   //       getAppliedWorkers(Token as string, selectedRequirement?._id as string, PaginatedData?.pageNo, PaginatedData?.pageSize).then((res) => {

   //          if (res?.data?.status_code === 200) {
   //             // console.log(res?.data?.data);
   //             // setAppliedWorkers(res?.data?.data?.result);
   //             setPaginatedData({
   //                ...PaginatedData,
   //                totalPages: res?.data?.data?.totalPages
   //             });
   //             // totalAppliedWorkersCount = res?.data?.data?.totalPages;
   //             // setTotalPages(res?.data?.data?.totalPages);
   //             setTotalAppliedData({
   //                ...totalAppliedData,
   //                appliedCount: res?.data?.data?.totalDocs,
   //                viewedCount: res?.data?.data?.viewsCount,
   //             });

   //             dispatch(stopLoading());
   //          } else {
   //             Swal.fire({
   //                icon: "error",
   //                title: "Oops...",
   //                text: `${res?.data?.data?.msg}`,
   //             });
   //          }
   //       });
   //    }

   // }, [selectedRequirement, PaginatedData?.pageSize, PaginatedData?.pageNo])


   const clearSearchValue = () => {
      setSearchVal("");  // Clear the search input
   };
   const handleInvoiceClick = async (id: string) => {
      if (!id) return;
      dispatch(startLoading());
      try {
         const res = await axios.get(`${AppConfig.DEV_SERVER}/invoice/${id}`, {
            headers: {
               "x-access-token": Token,
            },
            params: {
               type: "job_post",
            },
         });

         if (res?.data?.status_code === 200) {
            const pdfUrl = res?.data?.data?.file;
            // setPdf(pdfUrl);
            dispatch(stopLoading());
            // console.log(res)
            window.open(pdfUrl, "_blank"); // Open the PDF in a new tab
         } else {
            dispatch(stopLoading());
            Swal.fire({
               icon: "error",
               title: "Something Went Wrong...",
               text: `${res?.data?.msg}`,
            });
         }
      } catch (error) {
         dispatch(stopLoading());
         Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to fetch the invoice.",
         });
      }
   };


   const handlePageSizeChange = (e: any) => {
      setPageSize(e?.target?.value);
   }

   // const setHandlePageClick = (page: keyof sidePages) => {
   //    setClickedSidePage({
   //       appliedworkers: page === "appliedworkers"
   //    })
   // }

   return (
      <MainLayout
         showAllFilters={false}
         searchValue={searchVal}
         onChange={(e) => setSearchVal(e.target.value)}
         clearValChange={clearSearchValue}
         startDate={startDate}
         endDate={endDate}
         startDateOnChange={e => setStartDate(e)}
         endDateOnChange={e => setEndDate(e)}
         headers={headers}
         formattedData={formattedData}
         exportPDF={exportPDF}
      >

         <div className="main-div">

            <div className={` category-main me-2 p-3 p-md-4 card `} >
               {
                  loading ?
                     <div>
                        <LoadingGif />
                     </div>

                     : ""
               }

                     <div>
                  <div className="d-flex justify-content-between mb-3 flex-wrap ">
                     <h4 className="mb-3 mb-md-auto">
                              {`${selectedOption} Requirements`}
                           </h4>
                     <div className="d-flex justify-content-end gap-3 flex-wrap flex-md-nowrap">
                              <div className="d-flex gap-2">
                                 <span className="d-flex align-items-center pagesize-text">
                                    PageSize
                                 </span>

                                 <select
                                    className="form-select"
                                    style={{ backgroundPosition: "right 5px center", width: "60px" }}
                                    aria-label="Default select example"
                                    value={pageSize} // Bind the value to the state
                                    onChange={handlePageSizeChange} // Handle the change
                                 >
                                    <option value={20}>20</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                    <option value={200}>200</option>
                                 </select>
                              </div>
                              <div>
                                 <ExportDocs headers={headers} formattedData={formattedData} clickHandler={exportPDF} />
                              </div>


                              <div className="d-flex justify-content-end gap-4 w-100 w-md-60 w-lg-45 ">
                                 <FilterButton
                                    name={selectedOption}
                                    type="requirement"
                                    options={["Work", "Material", "Job"]}

                                 />
                              </div>

                           </div>


                        </div>
                        <div className="table-responsive">
                           <table className="table table-striped card-body">
                              <thead>
                                 <tr className="category-tr">
                                    <th scope="col" className="text-start ps-4">Sr.No.</th>
                                    <th scope="col" className="text-start ps-4">{selectedOption === "Work" ? "Requirement Id" : selectedOption === "Job" ? "Job Id" : "Material Id"}</th>
                                    <th scope="col" className="text-start ps-4">{selectedOption === "Job" ? "Job Requirement" : selectedOption === "Material" ? "Material Requirement" : "Work Requirement"} </th>
                                    <th scope="col" className="text-start ps-4">{selectedOption === "Job" ? 'Salery Offered' : "Estimated Budget"} </th>

                                    <th scope="col" className="text-start ps-4">{selectedOption === "Job" ? "Employer Name" : "Cutomer Name"} </th>
                                    {
                                       selectedOption === "Job" ?
                                          <th scope="col" className="text-start ps-4">vacancy Count</th> :
                                          ""
                                    }
                                    <th scope="col" className="text-start ps-4">Date</th>
                                    <th scope="col" className="cat_btns">Action</th>
                                 </tr>
                              </thead>

                              <tbody>

                                 {
                                    requirements && requirements?.map((data: IRequirement, i) => {
                                       const materialData = data?.material_requirement?.map((data) => data?.materialName);
                                       const joinDate = formatDiffrentDate(data?.createdAt);
                                       const rowNumber = (pageNo - 1) * pageSize + (i + 1);
                                       return (
                                          <tr key={data?._id}>

                                             <td className="text-start ps-4 pt-3">{rowNumber}</td>
                                             <td className="text-start ps-4 pt-3">{data?.unique_id}</td>
                                             <td className="text-start ps-4 pt-3">{selectedOption === "Job" ? data?.hiring_type?.[0] : selectedOption === "Material" ? materialData?.join(", ") : data?.work_requirement?.join(", ")}</td>
                                             <td className="text-start ps-4 pt-3">{selectedOption === "Job" ? data?.salary_offered : data?.estimated_budget}</td>

                                             <td className="text-start ps-4 pt-3">{data?.user_name}</td>
                                             {
                                                selectedOption === "Job" ?
                                                   <td className="text-start ps-4 pt-3">{data?.vacancy_count}</td> :
                                                   ""
                                             }

                                             <td className="text-start ps-4 pt-3"> {joinDate?.formattedDate}, <br />{joinDate?.formattedHours}</td>
                                             <td className="align-content-center ">
                                                <div className="d-flex justify-content-evenly gap-3">
                                                   <Link to={`/requirements/${data?._id}`}>

                                                      <button className="btn btn-sm delete_btn ">
                                                      <img src={eye} />
                                                   </button>
                                                   </Link>
                                                   {
                                                      selectedOption === "Job" ?
                                                         <button
                                                            className="btn btn-sm delete_btn"
                                                            onClick={() => {
                                                               handleInvoiceClick(data?._id);
                                                            }}
                                                            style={{ marginBottom: "1px" }}
                                                         >
                                                            <img src={bill} alt="invoice" />
                                                         </button> : ""

                                                   }

                                                </div>

                                             </td>
                                          </tr>
                                       )
                                    }
                                    )
                                 }


                              </tbody>

                           </table>

                        </div>



                        <Paginator
                           totalPages={totalPages}
                           pageNo={pageNo}
                           onPageChange={(e, no) => setPageNo(no)}
                           alignment="right"
                        />
                     </div>


            </div>

         </div>

      </MainLayout>
   )



};



export default WorkRequirements;